export default "__VITE_ASSET__CvJuYEck__"